import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCopy as faCopyRegular } from "@fortawesome/pro-regular-svg-icons"
import { faCopy as faCopySolid } from "@fortawesome/pro-solid-svg-icons"
import "./DuplicateButton.css"

/**
 * Reusable duplicate button for the curriculum editor view
 * @param {Function} onClick - runs when the button is clicked
 * @param {boolean} disable - whether to disable the button
 * @param {string} className - css class used for any custom styles
 * @returns {JSX.Element}
 */
const DuplicateButton = ({ onClick = () => null, disabled = false, className = "" }) => {
  const handleDuplicate = disabled ? () => null : onClick

  return (
    <button className={`curriculum-duplicate-button ${className}`} onClick={handleDuplicate} disabled={disabled}>
      <FontAwesomeIcon icon={faCopyRegular} className={disabled ? "show-always" : "show-by-default"} />
      {!disabled && <FontAwesomeIcon icon={faCopySolid} className="show-on-hover" />}
    </button>
  )
}

export default DuplicateButton
